import React from "react";

/* The Adel ★ mark — 4-point star matching the logo's A-star.
   Used as an eyebrow prefix, list bullet, and tagline separator.
   Decorative by default (aria-hidden). */
export function Star({ className, ...rest }) {
  return (
    <svg className={className} viewBox="0 0 24 24" aria-hidden="true" focusable="false" {...rest}>
      <path d="M12 0 L14.55 9.45 L24 12 L14.55 14.55 L12 24 L9.45 14.55 L0 12 L9.45 9.45 Z" />
    </svg>
  );
}

export default Star;
